import styled from "@emotion/styled";
import { Text } from "@components/typography";

export const StyledCaption = styled(Text)`
    display: block;
    margin-top: 6px;
`;
